export const REPORT_BY_ID = "/dashboard/report/:id"
